import { render, staticRenderFns } from "./changetime.vue?vue&type=template&id=2252098f&scoped=true"
import script from "./changetime.vue?vue&type=script&lang=js"
export * from "./changetime.vue?vue&type=script&lang=js"
import style0 from "./changetime.vue?vue&type=style&index=0&id=2252098f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252098f",
  null
  
)

export default component.exports